/*::* HANDLE SCROLL *::*/
(function (window, document) {
  "use strict";
  const html = document.documentElement;
  let previousScrollY = 0;

  function pageScroll() {
    const currentScrollY = window.scrollY;
    const scrollDifference = previousScrollY - currentScrollY;
    if (currentScrollY <= 0) {
      html.classList.remove(
        "page-scrolling",
        "page-scrolling--up",
        "page-scrolling--down"
      );
    } else {
      html.classList.add("page-scrolling");
      if (scrollDifference > 0) {
        html.classList.add("page-scrolling--up");
        html.classList.remove("page-scrolling--down");
      } else {
        html.classList.add("page-scrolling--down");
        html.classList.remove("page-scrolling--up");
      }
    }
    previousScrollY = currentScrollY;
  }

  pageScroll();

  window.addEventListener("scroll", () => {
    pageScroll();
  });

  document.addEventListener("DOMContentLoaded", () => {
    pageScroll();
  });
})(window, document);

/*::* INJECT CSS TO SHADOW DOM *::*/
document.addEventListener("DOMContentLoaded", () => {
  // const formContainer = document.querySelector('.form-container');

  const observer = new MutationObserver((mutationsList, observer) => {
    const form = document.querySelector("form-embed");

    if (form) {
      observer.disconnect();
      const shadow = form.shadowRoot;

      // const sheet = new CSSStyleSheet();
      // sheet.insertRule(`

      // `);
      // shadow.adoptedStyleSheets.push(sheet);
      // formContainer.classList.add('loaded');

      const style = document.createElement("style");
      style.textContent = `
        #form-container-ref > * {
          font-family: "Archivo", "FC Iconic", "sans-serif";
        }

         #form-container-ref [data-sizing="form-wrapper"] {
           max-width: 661px;
         }
      
         #form-container-ref h2 {
           font-size: 48px;
           line-height: 1;
           text-transform: uppercase;
           font-weight: 600;
           margin-bottom: 56px;
         }

        #form-container-ref form {
          flex-direction: row;
          flex-wrap: wrap;
          gap: 24px 10px;
        }

        #form-container-ref form > * {
          width: 100%;
        }

        #form-container-ref form > *:is(:nth-child(2), :nth-child(3)) {
          width: calc(50% - 5px);
        }
         
        #form-container-ref input, 
        #form-container-ref textarea {
          border-radius: 0 !important;
          order: 1;
          padding: 10px 15px;
          min-height: 26px;
          color: rgba(0, 0, 0, 0.5);
        }

        #form-container-ref button {
          border-radius: 0 !important;
        }

        #form-container-ref label,
        #form-container-ref [class*="_formFileInput"] > p {
          display: block;
          position: static;
          order: 0;
          font-size: 15px;
          line-height: 1.2;
          font-weight: 600;
          text-transform: uppercase;
          transform: unset;
          color: #000;
          margin-bottom: 10px !important;
        }

        #form-container-ref [class*="_formPhoneInputContainer"] {
          position: relative;
          grid-template-columns: 80px 1fr
        }

        #form-container-ref [class*="_formPhoneInputContainer"] label {
          transform: translateX(-88px);
        }

        #form-container-ref [class*="_formPhoneInputContainer"] button {
          margin-top: 28px;
        }

        #form-container-ref form > button[type="submit"] {
            width: fit-content;
            padding: 15px 40px;
            margin: 0 auto;
            text-transform: uppercase;
        }

        #form-container-ref [class*="_formDisclaimer"] {
          max-width: 450px;
          margin: 0 auto;
        }

        #form-container-ref [class*="_formFileInput"] > button {
          margin-top: 0;
          border: none;
          box-shadow: var(--form-field-border);
          justify-content: flex-start;
          align-items: center;
          grid-gap: 8px;
          padding: 10px 15px;     
          min-height: 46px;
        }

        #form-container-ref [class*="_formFileInput"] > button:before {
          content: "";
          width: 12px;
          aspect-ratio: 1;
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
          background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path opacity="0.5" d="M5.41667 8.98067V1.77234L3.47438 3.71463L2.88458 3.11525L5.83333 0.166504L8.78208 3.11525L8.19229 3.71463L6.25 1.77234V8.98067H5.41667ZM1.34625 11.8332C0.962639 11.8332 0.642361 11.7047 0.385417 11.4478C0.128472 11.1908 0 10.8705 0 10.4869V8.46775H0.833333V10.4869C0.833333 10.6153 0.886736 10.7328 0.993542 10.8396C1.10035 10.9464 1.21792 10.9998 1.34625 10.9998H10.3204C10.4488 10.9998 10.5663 10.9464 10.6731 10.8396C10.7799 10.7328 10.8333 10.6153 10.8333 10.4869V8.46775H11.6667V10.4869C11.6667 10.8705 11.5382 11.1908 11.2813 11.4478C11.0243 11.7047 10.704 11.8332 10.3204 11.8332H1.34625Z" fill="black"/></svg>');
        }

        #form-container-ref [class*="_formFileInput"] > button > p {
          margin: 0 !important;
          padding: 0 !important;
          background-color: transparent;
          color: rgba(0, 0, 0, 0.5);
          text-transform: unset;
          font-size: 12px;
          font-weight: 400px;
          line-height: 1.3333;
          font-family: "Work Sans", "sans-serif",
        }

        @media (max-width: 576px) {
          #form-container-ref form > *:is(:nth-child(2), :nth-child(3)) {
            width: 100%;
          }
        }
      `;
      shadow.appendChild(style);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

/*::* MOVE ALL SALES TAX *::*/
document.addEventListener("DOMContentLoaded", () => {
  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;

        // If the added node *is* a sale tag
        if (node.classList.contains("hc-sale-tag")) {
          moveSaleTag(node);
        }

        // Or if the added node *contains* sale tags
        const nestedTags = node.querySelectorAll?.(".hc-sale-tag");
        nestedTags?.forEach(moveSaleTag);
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  function moveSaleTag(saleTag) {
    const cardWrapper =
      saleTag.closest(".card-wrapper") ||
      saleTag.parentElement?.querySelector(".card-wrapper");

    if (!cardWrapper) return;

    const saleTagParent = saleTag.parentElement;
    const cardWrapperParent = cardWrapper.parentElement;

    if (saleTagParent !== cardWrapperParent) {
      // Move it before or after as needed
      cardWrapperParent.insertBefore(saleTag, cardWrapper);
    }
  }
});

/*::* PC Submenu *::*/
document.addEventListener("DOMContentLoaded", () => {
  const headerSubmenu = document.querySelector('.menu_left_block .header__submenu');

  if (!headerSubmenu) return;

  headerSubmenu.querySelectorAll('li').forEach(li => {
    if (li.querySelector('ul')) {
      li.classList.add('has-second-level-submenu');

      const trigger = li.querySelector(".header__menu-item"); // single element
      if (trigger) {
        trigger.addEventListener('click', e => {
          e.preventDefault(); // stop navigation, still allows hover
        });
      }
    }
  });
});
